import type { ReactNode } from 'react';
import { TrashIcon } from '@phosphor-icons/react';

import { Button } from '@/components/ui/button';

/** Stored rules this version can't read, listed so they can be deleted. */
export function UnreadableRuleList({
  ids,
  onDelete,
  isBusy,
  warning,
  deleteLabel,
}: {
  ids: string[];
  /** Null hides the action: the viewer may not delete. */
  onDelete: ((id: string) => void) | null;
  isBusy: boolean;
  warning: ReactNode;
  deleteLabel: ReactNode;
}) {
  if (ids.length === 0) return null;
  return (
    <div className="flex flex-col gap-1 text-sm">
      <p className="text-destructive">{warning}</p>
      {ids.map((id) => (
        <div key={id} className="flex items-center gap-2">
          <span className="font-mono text-xs">{id}</span>
          {onDelete ? (
            <Button
              size="sm"
              variant="ghost"
              disabled={isBusy}
              onClick={() => onDelete(id)}
            >
              <TrashIcon className="h-4 w-4" />
              {deleteLabel}
            </Button>
          ) : null}
        </div>
      ))}
    </div>
  );
}
